import { render, staticRenderFns } from "./BatteryComponentSettings.vue?vue&type=template&id=2b9e7670&"
import script from "./BatteryComponentSettings.vue?vue&type=script&lang=ts&"
export * from "./BatteryComponentSettings.vue?vue&type=script&lang=ts&"
import style0 from "./BatteryComponentSettings.vue?vue&type=style&index=0&id=2b9e7670&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports